import { useMemo } from "react";

import TableSimpleCell from "ds/components/TableSimple/Cell";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import { IntentResource } from "types/generated";
import TableCellLink from "ds/components/Table/Row/CellLink";

import useCellCopyAction from "../useCellCopyAction";
import { showIntentProjectResourceDetailsDrawer } from "../../Details";

const IntentProjectResourcesTableIdCell = ({
  item: resource,
  ...cellProps
}: TableSimpleCellProps<IntentResource>) => {
  const copyAction = useCellCopyAction({
    text: resource.resourceID,
  });

  const handlePress = () => {
    showIntentProjectResourceDetailsDrawer({ resource });
  };

  const actions = useMemo(() => [copyAction], [copyAction]);

  return (
    <TableSimpleCell {...cellProps} role="rowheader" actions={actions}>
      <TableCellLink onPress={handlePress}>{resource.resourceID}</TableCellLink>
    </TableSimpleCell>
  );
};

export default IntentProjectResourcesTableIdCell;
